import { Link } from 'react-router-dom';
export default function Pricing() {
  return <section id="pricing" className="studio-scope"><div className="studio-shell scope-layout">
    <h2>เริ่มจากกระบวนการเดียว</h2>
    <p className="scope-description">เลือกงานที่ทีมทำซ้ำบ่อย เราจะประเมินงานและเสนอราคาตามขอบเขตนั้น รวมค่าใช้จ่ายซอฟต์แวร์และการดูแลต่อเนื่อง</p>
    <Link to="/th/#request-demo" className="scope-link">ขอดูเดโม</Link>
  </div></section>;
}
